import { getWeChatInfo } from "../services/weChat"

const wx = window.wx;

export const initShare = async (shareConfig = {
    shareTitle: `${sessionStorage['blessNum']?"十九届六中全会学习手册来了！我是第"+sessionStorage['blessNum']+"位学习者": "收藏学习！十九届六中全会学习手册来了！"}`,
    shareUrl: window.location.origin + window.location.pathname + "#/",
    shareIcon: "https://res.mp.oeeee.com/h5static/v21/sjjlzqh/share.jpg",
    shareDesc: "一起学习打卡吧！"
}) => {
    if (window.nfplusJsbridge) {
        window.nfplusJsbridge.setShareInfo({
            shareDesc: shareConfig.shareDesc,
            shareIcon: shareConfig.shareIcon,
            shareTitle: shareConfig.shareTitle,
            shareUrl: shareConfig.shareUrl
        })
    }
    let shareInfo = await getWeChatInfo();
    const wxShareApiList = [
        "onMenuShareTimeline",
        "onMenuShareAppMessage",
        "onMenuShareQQ",
        "onMenuShareWeibo",
        "onMenuShareQZone"
    ];
    wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: shareInfo.app_id, // 必填，公众号的唯一标识
        timestamp: shareInfo.timestamp, // 必填，生成签名的时间戳
        nonceStr: shareInfo.nonceStr, // 必填，生成签名的随机串
        signature: shareInfo.signature, // 必填，签名，见附录1
        jsApiList: [
            "onMenuShareTimeline",
            "onMenuShareAppMessage",
            "onMenuShareQQ",
            "onMenuShareWeibo",
            "onMenuShareQZone",
        ] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
    });
    const wxShareConfig = () => ({
        title: shareConfig.shareTitle,
        desc: shareConfig.shareDesc,
        link: shareConfig.shareUrl,
        imgUrl: shareConfig.shareIcon,
        success: () => {
            // // 分享地图埋点: 疫情页面分享
            // savePoint({
            //     dataType: 1000099,
            //     origin: 2,
            //     action: "2"
            // })
        },
    });
    wx.ready(() => {
        for (const [index, item] of wxShareApiList.entries()) {
            wx[item](wxShareConfig());
        }
    });
}